import React from 'react';
const testimonials = [{
  name: 'Marta R.',
  role: 'Docente Arte — Scuola Media, Milano',
  rating: 5,
  quote: 'Ho recuperato i miei weekend. Le slide LIM su Caravaggio hanno conquistato anche i ragazzi di terza più difficili. Non torno più indietro.',
  initial: 'M'
}, {
  name: 'Giuseppe T.',
  role: "Docente Storia dell'Arte — Liceo, Roma",
  rating: 5,
  quote: 'Il manuale BES/DSA è oro puro. Ho una classe con 4 ragazzi DSA e finalmente seguono la lezione come tutti gli altri.',
  initial: 'G'
}, {
  name: 'Chiara F.',
  role: 'Docente Arte — Scuola Media, Bologna',
  rating: 5,
  quote: 'Pagato in 5 minuti, scaricato tutto, lezione pronta per il giorno dopo. La Dirigente mi ha fatto i complimenti per la programmazione.',
  initial: 'C'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-221">
      <div className="max-w-5xl mx-auto" data-id="element-222">
        <div className="text-center mb-12" data-id="element-223">
          <span className="inline-block bg-secondary/10 text-secondary border border-secondary/20 font-bold text-xs sm:text-sm px-4 py-1.5 rounded-full mb-4 tracking-wider uppercase" data-id="element-224">
            ⭐ Recensioni Verificate
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight" data-id="element-225">
            Cosa dicono i docenti
          </h2>
          <p className="text-text-sec text-base sm:text-lg mt-3" data-id="element-226">
            Oltre <span className="text-primary font-bold" data-id="element-227">1.500 docenti</span>{' '}
            italiani hanno già scelto Arte Pronta
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-228">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-6 sm:p-7 flex flex-col gap-4 hover:border-primary/40 transition-colors" data-id="element-229">
              <div className="text-secondary text-lg" aria-label={`${t.rating} stelle`} data-id="element-230">
                {'⭐'.repeat(t.rating)}
              </div>
              <p className="text-text-main text-base leading-relaxed font-medium italic flex-1" data-id="element-231">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-232">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-orange-600 flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-233">
                  {t.initial}
                </div>
                <div className="min-w-0" data-id="element-234">
                  <p className="text-text-main font-bold text-sm" data-id="element-235">{t.name}</p>
                  <p className="text-text-sec text-xs leading-tight" data-id="element-236">
                    {t.role}
                  </p>
                </div>
                <span className="ml-auto text-check-green text-[10px] font-bold uppercase tracking-wider flex items-center gap-1 flex-shrink-0" title="Acquisto verificato" data-id="element-237">
                  ✓
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}